"use strict";

// set default speed
jQuery.fx.speeds.slow = 800;
jQuery.fx.speeds._default = 400;
jQuery.fx.speeds.fast = 200;

// init object
var he = {
    version: 1.0,
    contact: {
        copyright: "helionmedia GmbH",
        email: "info@helionmedia.de",
        phone: "+49 89 999 87 59 0",
        www: "https://www.helionmedia.de/",
        www2: "http://www.helionmedia-group.com/"
    },
    home: {
        animate: {},
        projects: {}
    },
    archive: {
        customers: {},
        projectcategories: {}
    },
    pages: {
        contact: {},
        aboutUs: {}
    },
    posts: {
        locations: {}
    },
    taxonomy: {
        customersDetail: {}
    },
    career: {
        vacancies: {}
    },
    footer: {},
    customizer: {
        sections: {}
    },
    slugs: {
        taxonomies: {},
        pta: {}
    },
    swiperOptions: {
        speed: jQuery.fx.speeds._default,

        autoHeight: false,
        updateOnImagesReady: true,
        lazyLoadingInPrevNext: true,
        centeredSlides: true,

        //ui
        grabCursor: true,

        // pagination
        pagination: '.swiper-pagination',
        paginationClickable: true,

        // arrows
        prevButton: '.swiper-button-prev',
        nextButton: '.swiper-button-next',

        // ARIA
        a11y: true,
        prevSlideMessage: 'Vorheriger Slide.',
        nextSlideMessage: 'Nächster Slide.',
        firstSlideMessage: 'Dies ist der erste Slide.',
        lastSlideMessage: 'Dies ist der letzte Slide.',
        paginationBulletMessage: 'Gehe zu slide {{index}}'
    }
};